import { Injectable } from '@angular/core';
import { Store, State } from '@ngxs/store';
import { CollectionDataServiceBase } from '@portal-core/data/collection/services/collection-data.service.base';
import { CollectionStateBase } from '@portal-core/data/collection/services/collection-state.base';
import { CollectionStateSelectors } from '@portal-core/data/collection/services/collection-state-selectors.decorator';
import { LogStreamRow } from '@portal-core/processes/models/log-stream-row.model';

@CollectionStateSelectors({
  stateType: LogStreamRowState
})
@State<LogStreamRowState>({
  name: LogStreamRowState.source,
})
@Injectable()
export class LogStreamRowState extends CollectionStateBase {
  static source = 'LogStreamRow';
  getSource(): string {
    return LogStreamRowState.source;
  }
}

@Injectable({
  providedIn: 'root'
})
export class LogStreamRowDataService extends CollectionDataServiceBase<LogStreamRow> {
  constructor(protected store: Store) {
    super(store, LogStreamRowState);
  }
}
